import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"20px"} }

import { reactive, ref, Ref, onMounted } from "vue";
import { post } from "../utils/request";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestPay',
  setup(__props) {

const testContent = reactive({ value: "" });
const tokenInput = reactive({ value: "086a14e8-7e1a-424a-885a-e5279b8ae1f0" });
const orderInput = reactive({ value: "" });
const payMethod = reactive({ value: "" });

// 获取用户代理字符串
let userAgent = navigator.userAgent.toLowerCase();

// 判断是否在支付宝内打开
if (userAgent.indexOf("alipay") !== -1) {
  // console.log('在支付宝内打开');
  payMethod.value = "ALIPAY";
}

// 判断是否在微信内打开
if (userAgent.indexOf("micromessenger") !== -1) {
  // console.log('在微信内打开');
  payMethod.value = "WEIXIN";
}

let getUrlParams = new URLSearchParams(window.location.search);

orderInput.value = getUrlParams.get("orderNum");

onMounted(() => {
  getOrderDetail();
});

const getOrderDetail = () => {
  let orderParams = {
    userId: 0,
    id: orderInput.value,
  };

  post(
    "https://test.sancttech.com:9939/v3/huan/order/getOrderDetail",
    orderParams,
    {
      "Content-Type": "application/json",
      Authorization: "Bearer " + tokenInput.value,
    }
  )
    .then((res) => {
      testContent.value = JSON.stringify(res.data);
      setTimeout(() => toPay(), 300);
    })
    .catch((error) => {
      alert(JSON.stringify(error));
    });
};

const toPay = () => {
  let payParams = {
    channelType: payMethod.value,
    orderNum: orderInput.value,
    tradeType: "MWEB",
  };

  // alert(JSON.stringify(payParams));

  post("https://test.sancttech.com:9939/v3/startpay/payRest/init", payParams, {
    "Content-Type": "application/json",
    Authorization: "Bearer " + tokenInput.value,
  })
    .then((res) => {
      alert(JSON.stringify(res.data));
      alipayPay(res.data);
    })
    .catch((error) => {
      alert(JSON.stringify(error));
    });
};

const alipayPay = (data) => {
  let div = document.createElement("div");
  div.innerHTML = data;
  document.body.appendChild(div);
  setTimeout(() => {
    document.forms[0].submit();
  }, 100);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(testContent.value), 1),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: toPay
    }, {
      default: _withCtx(() => [
        _createTextVNode("去支付")
      ]),
      _: 1
    })
  ]))
}
}

})